/* Enquiry form: shows the extra fields for the chosen enquiry type, and moves focus to any
   success or error message after submit. Without JS the extra fields stay hidden and the form still works. */
(() => {
  document.querySelectorAll('form[data-enquiry]').forEach((form) => {
    const select = form.querySelector('[data-enquiry-type]');
    if (select) {
      const groups = [...form.querySelectorAll('[data-extra-for]')];
      const sync = () => {
        const key = select.selectedOptions[0]?.dataset.key;
        groups.forEach((group) => {
          const show = group.dataset.extraFor === key;
          group.hidden = !show;
          group.querySelectorAll('input, select').forEach((field) => {
            field.disabled = !show;
            field.required = show && field.hasAttribute('data-required');
          });
        });
      };
      select.addEventListener('change', sync);
      sync();
    }
    form.querySelector('[data-focus-me]')?.focus();
  });
})();
